import { render } from "./Warehouse.vue?vue&type=template&id=2a3691fc&scoped=true"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"

import "./Warehouse.vue?vue&type=style&index=0&id=2a3691fc&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3691fc"]])

export default __exports__